import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightningBolt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLightningBolt"><Path d="M14.1035 9H19.543L9.1582 22.3516L9.89258 15H4.45312L14.8379 1.64844L14.1035 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightningBolt;
